import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G filter="url(#filter0_d_5322_29862)">
      <Circle cx={20} cy={18} r={16} fill={props.bgColor || "white"} />
    </G>
    <Path
      d="M19.8531 9.3671C21.2273 9.40241 22.6103 9.69372 23.7466 10.7001C25.0327 11.83 25.3498 13.622 24.6011 15.158C24.1518 16.0849 23.5088 16.8441 22.7424 17.515C22.346 17.8593 21.9144 18.177 21.562 18.5655C21.1921 18.9804 20.9718 19.457 20.919 20.0132C20.8926 20.278 20.8926 20.5517 20.8749 20.8253C20.8397 21.5845 20.5666 21.8846 19.8267 21.9729C19.58 21.9994 19.3334 21.9994 19.0867 21.9817C18.5142 21.9288 18.1882 21.6286 18.1266 21.0019C17.9416 19.2275 18.3908 17.6827 19.8531 16.5263C20.364 16.1202 20.9014 15.7318 21.3418 15.2375C21.5885 14.9638 21.7734 14.6548 21.8527 14.2929C22.0994 13.1894 21.4739 12.3861 20.1967 12.2184C19.7474 12.1566 19.2805 12.1654 18.8313 12.2802C18.4173 12.3861 18.0473 12.5892 17.7742 12.9334C17.6333 13.1188 17.4923 13.313 17.3514 13.4984C16.9198 14.0722 16.4176 14.2135 15.7834 13.9398C15.1844 13.6838 14.8497 13.1012 14.9642 12.4656C15.1932 11.1414 16.0829 10.3734 17.2369 9.86144C18.0297 9.49068 18.8929 9.37592 19.8531 9.3671Z"
      fill={props.color || "#242424"}
    />
    <Path
      d="M21.3332 25.592C21.3244 26.6072 20.4523 27.4723 19.4393 27.4723C18.4175 27.4723 17.5806 26.6072 17.5894 25.5655C17.5982 24.5327 18.4615 23.6587 19.4657 23.6852C20.4875 23.7029 21.342 24.5768 21.3332 25.592Z"
      fill={props.color || "#242424"}
    />
    <Defs />
  </Svg>
);
export default SVGComponent;
